module.exports = __webpack_public_path__ + "img/avatar-287.31ff0231.png";